import { useCallback, useState } from 'react'

const useSignature = () => {
    // Raw signature
    const [value, setValue] = useState('')
    // Formated signature visible on preview
    const [formatedSignature, setFormatedSignature] = useState('')
    // Signature for endpoint
    const [signature, setSignature] = useState<string[]>([])

    const handleChange = useCallback(
        (text: string) => {
            const lines = text.split('\n')

            let formattedText = ''

            // Loop through text lines,
            // crop every line if has more then 18 characters and
            // move text to next line
            for (const line of lines) {
                for (
                    let charIndex = 0;
                    charIndex < line.length;
                    charIndex += 18
                ) {
                    formattedText += `${line.slice(
                        charIndex,
                        charIndex + 18
                    )}\n`
                }
            }

            // remove last newline if not intentionally written
            if (lines[lines.length - 1] !== '')
                formattedText = formattedText.replace(/(\n)$/, '')

            // Cropt text if has more thane 3 lines
            formattedText = formattedText.split('\n').slice(0, 3).join('\n')

            setValue(text)
            setFormatedSignature(formattedText)
            // Create array with signature lines for endpoint
            setSignature(formattedText === '' ? [] : formattedText.split('\n'))
        },
        [value]
    )

    return {
        handleChange,
        value,
        formatedSignature,
        signature,
    }
}

export default useSignature
